module.exports = __webpack_public_path__ + "img/moneybag.840b875e.svg";